import { defineStore } from "pinia";
import ApiService from "~/services/ApiService";

export const useBonusStore = defineStore("bonus", () => {
  const rollovers = ref([]);  
  const activeRollover = ref(null);  
  const modalActive = ref(false);
  const modalExclude = ref(false);
  const modalRedeemActive = ref(false);
  const id = ref();

  async function getRollovers() {
    try {
      const response = await ApiService.get("/api/bonus?active=1");
      
      if (response?.data?.data) {
        rollovers.value = response.data.data;
       
      if (Array.isArray(response.data.data)) {
          activeRollover.value = response.data.data.find(
            (rollover) => rollover.active === 1
          ) || null;
        }
      } else {
        rollovers.value = [];
        activeRollover.value = null;
      }
    } catch (error) {
      console.error('Error fetching rollovers:', error);
      rollovers.value = [];
      activeRollover.value = null;
    }
  }

  async function setActiveRollover() {
    try {
      await ApiService.post(`/api/active/${id.value}`);
      await getRollovers();
    } catch (error) {
      console.error('Error setting active rollover:', error);
    }
  }

  async function redeemRollover() {
    try {
      const { data } = await ApiService.post(`/api/redeem/${id.value}`);
      await getRollovers();
      return data;
    } catch (error) {
      console.error('Error redeeming rollover:', error);
      throw error;
    }
  }

  const toggleActiveModal = () => {
    modalActive.value = !modalActive.value;
  };

  const toggleExcludeModal = () => {
    modalExclude.value = !modalExclude.value;
  };

  const toggleRedeemModal = () => {
    modalRedeemActive.value = !modalRedeemActive.value;
  };

  async function excludeRollover() {
    try {
      await ApiService.delete(`/api/bonus/${id.value}`);
      await getRollovers();
    } catch (error) {
      console.error('Error excluding rollover:', error);
      throw error;
    }
  }

  return {
    id,
    rollovers,
    activeRollover,
    modalActive,
    modalExclude,
    modalRedeemActive,

    getRollovers,
    redeemRollover,
    setActiveRollover,
    toggleActiveModal,
    toggleExcludeModal,
    toggleRedeemModal,
    excludeRollover,
  };
});